import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from '../../global/global';

export class NewUserRequest{
  constructor(
    public email: string,
    public name: string,
    public password: string,
    public country: string
  ){}
}
@Injectable({
  providedIn: 'root'
})

export class SignupService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  public signup(req: NewUserRequest){
    return this.httpClient.post(Global.BASE_API_URL + "/api/auth/signup", req);
  }
}
